const LOW_BATTERY_PERCENT = 15;
const CRITICAL_BATTERY_PERCENT = 5;

export async function initKioskBatteryIndicator() {
    const indicator = document.getElementById('kiosk_battery');
    if (!indicator || typeof navigator.getBattery !== 'function') {
        return;
    }

    const battery = await navigator.getBattery();
    const percentEls = indicator.querySelectorAll('.kiosk-battery__percent');

    const render = () => {
        const percent = Math.round(battery.level * 100);
        indicator.style.setProperty('--battery-level', `${percent}%`);
        percentEls.forEach((el) => {
            el.textContent = percent;
        });
        indicator.classList.toggle('kiosk-battery--charging', battery.charging);
        const critical = !battery.charging && percent <= CRITICAL_BATTERY_PERCENT;
        indicator.classList.toggle('kiosk-battery--critical', critical);
        indicator.classList.toggle('kiosk-battery--low', !critical && !battery.charging && percent <= LOW_BATTERY_PERCENT);
        indicator.setAttribute('aria-label', `Battery ${percent}%${battery.charging ? ', charging' : ''}`);
    };

    render();
    battery.addEventListener('levelchange', render);
    battery.addEventListener('chargingchange', render);
    indicator.classList.remove('d-none');
}
